import React, { Component } from "react";
import { DataTable, ExportCSV } from "../../../../components";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { getTopCustomers } from "../../../../store/dashboard/actions";
import { layout, roles, messages } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { Bar } from "react-chartjs-2";
import * as charts from "./_charts";
import * as columns from "./_columns";
import { selectTopCustomersChartData } from "../../../../store/dashboard/selector";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Collapse,
  Label,
} from "reactstrap";
import { getTopCustomers as topCustomersExport } from "../../../../service/dashboard";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import { exportExcel } from "./excel";

class CardTopCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTopClients: true,
      startDate: null,
      endDate: null,
      loadingExport: false,
      selectedStore: null,
      selectedStoreCompare: null,
    };
    this.handleObtainCustomerExport =
      this.handleObtainCustomerExport.bind(this);
  }

  async handleStoreChange(compare, value) {
    if (value == this.state.selectedStore) return;
    if (compare) {
      await this.setState({ selectedStoreCompare: value, page: 1 });
    } else {
      await this.setState({ selectedStore: value, page: 1 });
    }

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.props.getTopCustomers({
        page: this.state.pageDetails,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
        storeCompare: this.state.selectedStoreCompare.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
      this.setState({ selectedStoreCompare: this.props.stores[0] });
    }
  }

  handleTopCustomersDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null && this.state.selectedStore) {
      this.props.getTopCustomers({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
        storeCompare: this.state.selectedStoreCompare.value,
      });
    }
  }

  renderDataTable(columns, compare) {
    if (compare) {
      return (
        <DataTable
          data={this.props.topCustomersCompare}
          keyField="id"
          columns={columns}
          loading={this.props.loading}
        />
      );
    } else {
      return (
        <DataTable
          data={this.props.topCustomers}
          keyField="id"
          columns={columns}
          loading={this.props.loading}
        />
      );
    }
  }

  async handleObtainCustomerExport() {
    this.setState({ loadingExport: true });
    try {
      const { startDate, endDate, selectedStore, selectedStoreCompare } =
        this.state;
      const responseTopCustomers = await topCustomersExport(
        startDate ? startDate._d : null,
        endDate ? endDate._d : null,
        selectedStore.value
      );
      const responseTopCustomersCompare = await topCustomersExport(
        startDate ? startDate._d : null,
        endDate ? endDate._d : null,
        selectedStoreCompare.value
      );

      exportExcel(
        responseTopCustomers.data.data,
        responseTopCustomersCompare.data.data,
        selectedStore,
        selectedStoreCompare,
        startDate,
        endDate,
        this.props.role
      );
    } finally {
      this.setState({ loadingExport: false });
    }
  }

  render() {
    const { startDate, endDate, loadingExport } = this.state;
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showTopClients: !this.state.showTopClients })
          }
        >
          Top Clientes
        </CardHeader>
        <Collapse isOpen={this.state.showTopClients}>
          <CardBody>
            <MediaQuery minDeviceWidth={layout.SM_MIN_WIDTH}>
              {(matches) => {
                if (matches) {
                  return (
                    <div>
                      {(this.props.role == roles.SUPER_ADMIN ||
                        this.props.role == roles.ADMIN) && (
                        <Row className="my-4">
                          <Col sm="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col sm="5">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange.bind(
                                this,
                                false
                              )}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                          <Col sm="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col sm="5">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange.bind(this, true)}
                              value={this.state.selectedStoreCompare}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                        </Row>
                      )}
                      <Row className="mb-2">
                        <Col sm="7">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDateTopClients"
                            endDate={endDate}
                            endDateId="endDateTopClients"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleTopCustomersDateChange(
                                startDate,
                                endDate
                              )
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                            minimumNights={0}
                          />
                        </Col>
                        <Col sm="5">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={loadingExport}
                              exportCSV={this.handleObtainCustomerExport}
                              minWidth={layout.SM_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      {(this.props.role == roles.SUPER_ADMIN ||
                        this.props.role == roles.ADMIN) && (
                        <Row className="my-4">
                          <Col sm="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col sm="5">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange.bind(
                                this,
                                false
                              )}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                          <Col sm="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col sm="5">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange.bind(this, true)}
                              value={this.state.selectedStoreCompare}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                        </Row>
                      )}
                      <Row className="mb-2">
                        <Col sm="5">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDateTopClients"
                            endDate={endDate}
                            endDateId="endDateTopClients"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleTopCustomersDateChange(
                                startDate,
                                endDate
                              )
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            numberOfMonths={1}
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                          />
                        </Col>
                        <Col sm="5">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={loadingExport}
                              exportCSV={this.handleObtainCustomerExport}
                              minWidth={layout.SM_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <div>
                <Row>
                  <Col xl="7">
                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                      {this.renderDataTable(columns.topCustomersXS, false)}
                    </MediaQuery>
                    <MediaQuery
                      minWidth={layout.SM_MIN_WIDTH}
                      maxWidth={layout.MD_MAX_WIDTH}
                    >
                      {this.renderDataTable(columns.topCustomersSM, false)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                      {this.renderDataTable(columns.topCustomers, false)}
                    </MediaQuery>
                  </Col>
                  <Col xl="5">
                    <Bar
                      data={charts.topCustomersData(
                        this.props.topCustomersChartData
                      )}
                      options={charts.topCustomersOptions()}
                    />
                  </Col>
                </Row>
                {(this.props.role == roles.SUPER_ADMIN ||
                  this.props.role == roles.ADMIN) && (
                  <Row>
                    <Col xl="7">
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(columns.topCustomersXS, true)}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(columns.topCustomersSM, true)}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(columns.topCustomers, true)}
                      </MediaQuery>
                    </Col>
                    <Col xl="5">
                      <Bar
                        data={charts.topCustomersData(
                          this.props.topCustomersCompareChartData
                        )}
                        options={charts.topCustomersOptions()}
                      />
                    </Col>
                  </Row>
                )}
              </div>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione un rango de fechas para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { topCustomers, error, loading, topCustomersCompare } =
    state.dashboard.topCustomerList;
  return {
    topCustomers,
    topCustomersCompare,
    error,
    loading,
    topCustomersChartData: selectTopCustomersChartData(state, false),
    topCustomersCompareChartData: selectTopCustomersChartData(state, true),
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getTopCustomers,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardTopCustomer);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopCustomer/CardTopCustomer.js